var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.$t("PAGE_KPMG_ROLE_TITLE"),
        visible: "",
        width: "70%",
      },
      on: { close: _vm.onCancel },
    },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "demo-ruleForm",
          attrs: {
            model: _vm.ruleForm,
            rules: _vm.rules,
            inline: true,
            "label-width": "100px",
          },
        },
        [
          _c(
            "el-form-item",
            {
              staticClass: "form-item",
              attrs: {
                label: _vm.$t("TABLE_HEADER_roleName"),
                prop: "roleName",
              },
            },
            [
              _c("el-input", {
                staticClass: "form-input-item",
                attrs: { maxlength: "100" },
                model: {
                  value: _vm.ruleForm.roleName,
                  callback: function ($$v) {
                    _vm.$set(_vm.ruleForm, "roleName", $$v)
                  },
                  expression: "ruleForm.roleName",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "form-item",
              attrs: {
                label: _vm.$t("FORM_LABEL_description"),
                prop: "description",
              },
            },
            [
              _c("el-input", {
                staticClass: "form-input-item",
                attrs: { maxlength: "100" },
                model: {
                  value: _vm.ruleForm.description,
                  callback: function ($$v) {
                    _vm.$set(_vm.ruleForm, "description", $$v)
                  },
                  expression: "ruleForm.description",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("el-row", [
        _c("p", { staticClass: "title" }, [
          _vm._v(" " + _vm._s(_vm.$t("PAGE_CLIENTROLES_PERMISSION"))),
        ]),
      ]),
      _c(
        "el-row",
        { staticClass: "permission-box", attrs: { gutter: 16 } },
        [
          _c("el-col", { attrs: { span: 24 } }, [
            _c("div", { staticClass: "box-item" }, [
              _c("p", { staticClass: "item-title" }, [
                _c("span", [_vm._v("*")]),
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("COMMON_ENTITY")) +
                    "\n                    "
                ),
                _c("span", { staticStyle: { color: "#fd349c" } }, [
                  _vm._v(_vm._s(_vm.$t("kprole_entity_confirmation_tip"))),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "item-content with-select-all-tree" },
                [
                  _c("el-input", {
                    staticClass: "entity-input-sel",
                    attrs: { placeholder: _vm.$t("ENTER_SEARCH_CONTENT") },
                    model: {
                      value: _vm.filterText,
                      callback: function ($$v) {
                        _vm.filterText = $$v
                      },
                      expression: "filterText",
                    },
                  }),
                  _c("el-tree", {
                    ref: "tree",
                    attrs: {
                      "default-expand-all": true,
                      "check-strictly": true,
                      "expand-on-click-node": false,
                      data: _vm.data,
                      props: _vm.defaultProps,
                      "default-checked-keys": _vm.entityTreeCheckedList,
                      "render-content": _vm.renderContent,
                      "filter-node-method": _vm.filterNode,
                      "node-key": "key",
                      "show-checkbox": "",
                    },
                    on: { check: _vm.handleCheckChange },
                  }),
                ],
                1
              ),
            ]),
          ]),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { staticClass: "cancel-btn", on: { click: _vm.onCancel } },
            [_vm._v(_vm._s(_vm.$t("comment_reSet")))]
          ),
          _c(
            "el-button",
            {
              staticClass: "wl-green",
              attrs: { type: "primary", loading: _vm.saveLoading },
              on: { click: _vm.onConfirm },
            },
            [_vm._v(_vm._s(_vm.$t("btn_save")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }